export const BlankTemplate = {
    name: 'blank',
    label: 'Blank',
    subject: "",
    category: 'compulsory',
    body: "",
}
